import React from 'react'

import { styled } from '@mui/material/styles'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'

const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        fontSize: 11,
    },
}))

const CustomTooltip = ({ text, position, children }) => {
    return (
        <StyledTooltip title={text} placement={position}>
            {children}
        </StyledTooltip>
    )
}

export default CustomTooltip
